import React from 'react'
import { backgroundThemes, paddingSizes } from '../../../constants/contentfulStyle.constant'
import { LanguageSelect, LocaleCodesSlugPrefix } from '../../../constants/localization.constants'
import { setBackgroundTheme, setPaddingSize } from '../../../utils/contentfulStyles.utils'
import GlobalContainer from '../globalContainer'
import {
  CategoryHeader,
  CategoryIcon,
  CategoryLink,
  ResourceButton,
  ResourceHeader,
} from './resourceListParts'
import { Categories, ResourceListsContainer } from './styles'

const ResourceLists = ({ data }: any) => {
  if (!data) return null

  const langPrefix = LocaleCodesSlugPrefix[data.node_locale]
  const currLang =
    LanguageSelect.rows.find((language: any) => {
      return langPrefix === language.lang
    }) || LanguageSelect.rows[0] // English
  const uiPathUrl = currLang.href + '/'

  const topPaddingSize = setPaddingSize(data.topPadding, paddingSizes.LARGE.size)

  const bottomPaddingSize = setPaddingSize(data.bottomPadding, paddingSizes.LARGE.size)

  const isDarkTheme = data.theme === backgroundThemes.DARK

  const categories = data.linkCategories?.map((category: any) => (
    <div className="ResourceLists__Category" key={category.id}>
      <header className="Category__Header">
        <span className="Category__Icon">
          {
            <CategoryIcon
              colorImage={category.resourceCategory.colorImage}
              whiteImage={category.resourceCategory.whiteImage}
              isDarkTheme={isDarkTheme}
            />
          }
        </span>

        {<CategoryHeader titleOverride={category.titleOverride} name={category.name} />}
      </header>

      {category?.links?.map((link: any) => (
        <CategoryLink link={link} uiPathUrl={uiPathUrl} />
      ))}
    </div>
  ))

  const mid = Math.floor(categories.length / 2)

  return (
    <ResourceListsContainer
      data-cy="ResourceLists"
      isDarkTheme={isDarkTheme}
      topPaddingSize={topPaddingSize}
      bottomPaddingSize={bottomPaddingSize}
      backgroundColor={setBackgroundTheme(data.theme)}>
      <GlobalContainer className="ResourceLists__Grid">
        {<ResourceHeader title={data.title} />}
        {
          <ResourceButton
            ctaLabelOverride={data.ctaLabelOverride}
            ctaList={data.ctaList}
            theme={data.theme}
            uiPathUrl={uiPathUrl}
          />
        }

        <Categories isDarkTheme={isDarkTheme}>
          <div className="ResourceLists__Categories_Left">{categories.slice(0, mid)}</div>

          <div className="ResourceLists__Categories_Right">{categories.slice(mid)}</div>
        </Categories>
      </GlobalContainer>
    </ResourceListsContainer>
  )
}

export default ResourceLists
